// baseAPI.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
  baseUrl: " ", // Can be empty if you're using full URLs
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("token");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseAPI = createApi({
  reducerPath: "baseAPI",
  baseQuery: async (args, api, extraOptions) => {
    try {
      return await baseQuery(args, api, extraOptions);
    } catch (error) {
      return {
        error: {
          status: error?.status || "FETCH_ERROR",
          data: error?.data || error?.message || "Something went wrong",
        },
      };
    }
  },
  endpoints: () => ({}),
});

export default baseAPI;
